<template>
  <div>
    <el-page-header v-if="isInner" @back="$router.go(-1)" content="员工详情" />

    <el-empty v-if="!employee || !employee.id" description="待人事添加信息" />
    <div class="profile-container" v-else>
      <div class="overview flex-align-center">
        <div class="left flex-align-center">
          <div class="avatar">
            <div class="avatar">
              <el-upload
                ref="upload"
                :action="uploadAction"
                :headers="header"
                :on-success="handleUpload"
                :before-upload="beforeAvatarUpload"
                :show-file-list="false"
                name="file"
                accept="image/*"
                :auto-upload="false"
                :on-change="handleChangeUpload"
                :data="{ code: 'employee' }"
              >
                <img :src="avatar" style="width: 68px; height: 68px" alt="avatar" />
              </el-upload>
            </div>
          </div>
          <div class="info">
            <p class="fisrt">
              <span class="name">{{ employee.name }}</span>
              <el-tag size="small">工号：{{ employee.staffId || employee.id }}</el-tag>
            </p>
            <p class="description">
              <span v-if="!descEditVisible">{{ simpleData.description || '这个人很神秘~' }}</span>
              <el-input
                v-else
                v-model="simpleData.description"
                maxlength="100"
                size="mini"
                placeholder="输入个人描述"
                style="width: 300px"
                @change="descChange"
                @blur="descChange"
              />
              <i
                v-if="!descEditVisible && isSlef"
                class="el-icon-edit"
                style="margin-left: 6px; color: #3f9dfd; cursor: pointer"
                title="编辑个人描述"
                @click="descEditVisible = true"
              ></i>
            </p>
          </div>
        </div>
        <div class="right">
          <el-button type="primary" icon="el-icon-user" size="small" disabled
            >绑定账户：{{ bindAccount.label }}</el-button
          >
        </div>
      </div>

      <div class="info-content">
        <div class="info-section">
          <div class="divider">基础信息</div>
          <el-descriptions>
            <el-descriptions-item label="姓名">{{ employee.name }}</el-descriptions-item>
            <el-descriptions-item label="手机">{{ employee.phone }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{
              employee.gender === 1 ? '男' : '女'
            }}</el-descriptions-item>
            <el-descriptions-item label="民族">{{ employee.nation }}</el-descriptions-item>
            <el-descriptions-item label="政治面貌">{{ employee.politic }}</el-descriptions-item>
            <el-descriptions-item label="身份证">{{ employee.idCard }}</el-descriptions-item>
            <el-descriptions-item label="出生日期">{{ employee.birthdate }}</el-descriptions-item>
            <el-descriptions-item label="籍贯">{{ employee.nativePlace }}</el-descriptions-item>
            <el-descriptions-item label="身份证地址">{{
              employee.cardAddress
            }}</el-descriptions-item>
            <el-descriptions-item label="联系地址">{{ employee.address }}</el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="info-section" v-if="employee.eduInfo && employee.eduInfo.length > 0">
          <div class="divider">教育信息</div>
          <el-table :data="employee.eduInfo" style="width: 100%" stripe>
            <el-table-column label="学习时间">
              <template slot-scope="scope">
                {{ `${scope.row.admissionDate} 至 ${scope.row.graduationDate}` }}
              </template>
            </el-table-column>
            <el-table-column prop="degreeName" label="学历" />
            <el-table-column prop="school" label="学校" />
            <el-table-column prop="major" label="专业" />
          </el-table>
        </div>

        <div class="info-section">
          <div class="divider">岗位信息</div>
          <el-descriptions>
            <el-descriptions-item label="工号">{{
              employee.staffId || employee.id
            }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag size="small">{{ employee.statusName }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="职位">{{ employee.positionName }}</el-descriptions-item>
            <el-descriptions-item label="所属部门">{{
              employee.departmentName
            }}</el-descriptions-item>
            <el-descriptions-item label="入职日期">{{ employee.entryDate }}</el-descriptions-item>
            <el-descriptions-item v-if="employee.confirmationDate" label="转正日期">{{
              employee.confirmationDate
            }}</el-descriptions-item>
            <el-descriptions-item v-else label="转正日期">未转正</el-descriptions-item>
            <el-descriptions-item v-if="employee.contractDate" label="合同期限">{{
              employee.contractDate
            }}</el-descriptions-item>
            <el-descriptions-item v-if="employee.resignDate" label="离职日期">{{
              employee.resignDate
            }}</el-descriptions-item>
            <el-descriptions-item label="工作内容" class="job-content">
              <p v-if="!descJobContentVisible" style="margin: 0">{{ employee.jobContent }}</p>
              <el-input
                v-else
                type="textarea"
                v-model="simpleData.jobContent"
                maxlength="100"
                :row="3"
                size="mini"
                placeholder="输入工作内容"
                style="width: 500px"
                @change="jobContentChange"
                @blur="jobContentChange"
              />
              <i
                v-if="!descJobContentVisible && isSlef"
                class="el-icon-edit"
                style="margin-left: 6px; color: #3f9dfd; cursor: pointer"
                title="编辑工作内容"
                @click="descJobContentVisible = true"
              ></i>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="info-section" v-if="employee.tabs && employee.tabs.length > 0">
          <el-timeline>
            <el-timeline-item
              hide-timestamp
              v-for="(item, index) in employee.positionRecords"
              :key="index"
            >
              <span class="timeline-date">{{ item.date }}</span>
              <p class="timeline-content">{{ item.content }}</p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <div class="tabs-inner">
        <el-tabs v-model="tabActive" type="card" v-if="employee.tabs && employee.tabs.length > 0">
          <el-tab-pane
            :key="item.id"
            v-for="item in employee.tabs"
            :label="item.name"
            :name="item.id"
            style="overflow: auto; max-height: 250px"
          >
            <el-empty v-if="!item.value || item.value.length <= 0" :image-size="60" />
            <el-timeline v-else>
              <el-timeline-item hide-timestamp v-for="(tab, index) in item.value" :key="index">
                <span class="timeline-date">{{
                  tab.endDate ? tab.startDate + '~' + tab.endDate : tab.startDate
                }}</span>
                <p class="timeline-content">
                  {{ tab.content }}
                  <el-popover placement="right" trigger="click" v-if="tab.files">
                    <ul style="padding-left: 6px">
                      <li
                        v-for="item in tab.files"
                        :key="item.id"
                        style="
                          display: flex;
                          align-items: center;
                          font-size: 13px;
                          margin-bottom: 6px;
                        "
                      >
                        <span>{{ item.fileName }}</span>
                        <i
                          slot="reference"
                          class="el-icon-view"
                          style="
                            color: #409eff;
                            margin-left: 10px;
                            cursor: pointer;
                            font-size: 14px;
                          "
                          @click="handlePreview(item.fileUrl)"
                        ></i>
                        <el-image
                          ref="preview"
                          :src="item.fileUrl"
                          :preview-src-list="fileImage"
                          style="display: none"
                        />
                      </li>
                    </ul>
                    <el-button
                      type="text"
                      style="margin-left: 10px; padding: 0"
                      size="small"
                      slot="reference"
                      >关联附件</el-button
                    >
                  </el-popover>
                </p>
              </el-timeline-item>
            </el-timeline>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <log
      ref="logRef"
      v-if="employee && employee.id"
      :logs="logs"
      :logInfo="{ type: logType, linkId: employee.id }"
      @openCollapse="handlerOpenSollapse"
    />

    <el-dialog
      title="编辑头像"
      :visible.sync="avatarDialogVisible"
      class="crop-dialog"
      append-to-body
      width="20%"
      @close="dialogClose"
    >
      <div class="cropper" style="text-align: center">
        <VueCropper
          ref="cropper"
          :img="option.img"
          :outputType="option.outputType"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :infoTrue="option.infoTrue"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="avatarDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAvatar">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import { getEmployeeForProfile, saveEmployeeSimpleInfo } from '@/api/office/employee'
  import { getLogs } from '@/api/office/log'
  import LOG_TYPE from '@/components/log-info-office/log-type'
  import log from '@/components/log-info-office/log.vue'
  import { VueCropper } from 'vue-cropper'

  import defaultAvatar from '@/static/default-avatar.png'

  export default {
    components: {
      log,
      VueCropper
    },
    data() {
      return {
        avatar: defaultAvatar,
        activeName: 'base',
        avatarDialogVisible: false,
        previewImg: '', // 预览图片地址
        uploadAction: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        header: { Authorization: 'bearer ' + getToken() },
        option: {
          img: '', // 裁剪图片的地址
          outputType: 'png', // 裁剪生成图片的格式
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 200, // 默认生成截图框宽度
          autoCropHeight: 200, // 默认生成截图框高度
          fixed: true, // 是否开启截图框宽高固定比例
          infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        },
        employee: {},
        bindAccount: {
          label: '未绑定'
        },
        descEditVisible: false,
        descJobContentVisible: false,
        accountId: '',
        employeeId: '',
        isSlef: false,
        logs: [],
        isInner: false,
        logType: LOG_TYPE.employee,
        cropperImg: '',
        simpleData: {
          description: '',
          jobContent: ''
        },
        tabActive: 1,
        fileImage: []
      }
    },
    beforeRouteEnter(to, from, next) {
      const accountId = to.query.accountId
      const id = to.query.id
      next((e) => {
        e.accountId = accountId
        e.employeeId = id
        e.initData()
        e.isInner =
          from.path === ('/office/hr/employee/employee-list' && to.query.accountId) ||
          to.query.accountId
      })
    },
    beforeRouteUpdate(to, from, next) {
      const accountId = to.query.accountId
      const id = to.query.id
      this.accountId = accountId
      this.employeeId = id
      this.initData()
      next()
    },
    methods: {
      submitAvatar() {
        this.$refs.cropper.getCropBlob((blob) => {
          this.avatarDialogVisible = false
          this.avatar = URL.createObjectURL(blob)
          this.$refs.upload.submit()
        })
      },
      handleChangeUpload(file) {
        if (file.status !== 'ready') {
          return
        }
        const reader = new FileReader()
        reader.onload = (evt) => {
          this.option.img = evt.target.result
          this.avatarDialogVisible = true
        }
        reader.readAsDataURL(file.raw)
      },
      handleUpload(res) {
        const { code, data } = res
        if (code === 0) {
          this.avatar = data.url
          this.employee.avatar = data.url
          this.saveEmployee()
        }
      },
      beforeAvatarUpload(file) {
        const uploadTypes = ['jpg', 'jpeg', 'png']
        const filetype = file.name.replace(/.+\./, '')
        if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
          this.$message.warning('仅支持jpg、jpeg、png格式的图片')
          return false
        }
        const size = file.size / 1024 / 1024 < 2
        if (!size) {
          this.$message.error('上传头像图片大小不能超过 2MB')
          return false
        }
        return true
      },

      initData() {
        if (this.accountId && this.employeeId) {
          const allPermission = this.$store.state.user.acpermission || []
          const isSelf = this.$store.state.user.userInfo.userId === this.accountId
          if (!allPermission.includes('employee_detail') && !isSelf) {
            this.$message.error('没有找到对应信息')
            return
          }
        }
        this.$loading()
        getEmployeeForProfile({ accountId: this.accountId, id: this.employeeId })
          .then((res) => {
            const { code, data } = res
            if (code === 0 && data && data.id) {
              this.employee = data
              if (data.avatar) {
                this.avatar = data.avatar
              }
              this.simpleData.description = data.description
              this.simpleData.jobContent = data.jobContent
              this.bindAccount = { label: data.accountName }
              const currentUser = this.$store.getters.userInfo
              this.isSlef = currentUser.userId === data.accountId
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      descChange() {
        this.descEditVisible = false
        if (this.employee.description === this.simpleData.description) {
          return
        }
        if (!this.simpleData.description) {
          this.simpleData.description = ''
        }
        this.saveEmployee()
      },
      jobContentChange() {
        this.descJobContentVisible = false
        if (this.employee.jobContent === this.simpleData.jobContent) {
          return
        }
        if (!this.simpleData.jobContent) {
          this.simpleData.jobContent = ''
        }
        this.saveEmployee()
      },
      saveEmployee() {
        const params = {
          id: this.employee.id,
          avatar: this.employee.avatar,
          jobContent: this.simpleData.jobContent,
          description: this.simpleData.description
        }
        saveEmployeeSimpleInfo(params).then((res) => {
          const { code, msg } = res
          if (code === 0) {
            this.$message.success(msg)
            this.handlerOpenSollapse()
            this.initData()
          }
        })
      },
      handlerOpenSollapse() {
        getLogs({ type: 1, linkId: this.employee.id }).then((res) => {
          const { code, data } = res
          if (code === 0) {
            this.logs = data
          }
        })
      },
      dialogClose() {
        this.option.img = ''
      },
      handlePreview(fileUrl) {
        this.fileImage = []
        this.fileImage.push(fileUrl)
        this.$refs.preview[0].clickHandler()
      }
    }
  }
</script>

<style lang="scss" scope>
  .flex-align-center {
    display: flex;
    align-items: center;
  }

  .profile-container {
    margin: 0 auto;
    border-radius: 6px;
    width: calc(100% - 12px);
    background-color: #fff;
    overflow: hidden;
    color: #333;
    transition: 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  }

  .overview {
    justify-content: space-between;
    padding: 40px 30px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #ececec;
    .left {
      width: 50%;
    }
  }

  .el-page-header {
    margin: 0 auto 10px 6px;
    padding: 6px 30px;
    width: fit-content;
    background-color: #fff;
    border-radius: 6px;
  }

  .info-content {
    padding: 0 30px;
  }

  .info-section {
    padding: 10px 0 5px;
  }

  .info {
    margin-left: 20px;
    p {
      margin: 0;
    }
    .name {
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
    }
    .fisrt {
      display: flex;
      align-items: center;
    }
    .el-tag {
      margin-left: 14px;
    }
    .description {
      height: 28px;
      margin-top: 8px;
      font-size: 14px;
      color: #979797;
    }
  }

  .divider {
    margin: 0 15px 25px 0;
    font-weight: 600;
    position: relative;
    padding-left: 14px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      height: 15px;
      border-radius: 2px;
      border-left: 4px solid #409eff;
    }
  }

  .info-content .divider {
    margin-top: 20px;
  }

  .avatar {
    img {
      border-radius: 50%;
    }
  }

  .cropper {
    margin: 0 auto;
    width: 250px;
    height: 250px;
  }

  .timeline-date {
    font-size: 13px;
    margin-right: 20px;
    color: #8f8f8f;
  }

  .timeline-content {
    margin: 6px 0 0;
  }

  .tabs-container {
    padding: 10px 6px 0;
  }

  .tabs-inner {
    border-radius: 6px;
    padding: 20px 30px;
    background-color: #fff;
  }
</style>
